"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuitePrefixes = void 0;
var auth_suite_prefixes_1 = require("./auth-suite-prefixes");
Object.defineProperty(exports, "AuthSuitePrefixes", { enumerable: true, get: function () { return auth_suite_prefixes_1.AuthSuitePrefixes; } });
